/**
 * Format an actor's display name, optionally suffixing the impersonator when
 * the record was created during an impersonation session.
 *
 * Backed by the showImpersonatorAttribution SuperAdmin setting — when off,
 * the impersonator is never shown.
 *
 * @param {Object} actor - the user the action was performed AS (createdByUser)
 * @param {Object} [impersonatedBy] - the actual SuperAdmin / granted user
 *                                     (createdByImpersonator), null on normal writes
 * @param {boolean} showAttribution - the live setting value
 * @returns {string} e.g. "Akash" or "Akash (impersonated by Vishnu)"
 */
export function formatActor(actor, impersonatedBy, showAttribution) {
  if (!actor) return '—';
  const base = actor.name || actor.email || '—';
  if (!showAttribution || !impersonatedBy?.name) return base;
  return `${base} (impersonated by ${impersonatedBy.name})`;
}

/**
 * Same idea but returns a React-friendly tuple { base, suffix } so the caller
 * can render the suffix in a muted color without rebuilding the string.
 */
export function actorParts(actor, impersonatedBy, showAttribution) {
  const base = actor?.name || actor?.email || '—';
  const suffix = (showAttribution && impersonatedBy?.name)
    ? ` (impersonated by ${impersonatedBy.name})`
    : '';
  return { base, suffix };
}
